export interface CuriosidadesContent {
	title: string;
}

export const curiosidadesContent: CuriosidadesContent = {
	title: "DIMENSÕES ÉPICAS",
};
